import React from 'react';
import { NavBar } from '@spotify-internal/s4x-masthead';
import styled from 'styled-components';
import { creatorLightTheme, screenSmMax, spacer72 } from '@spotify-internal/encore-web';

const Spacer = styled.div`
  height: 92px; /* navbar height: 76px, + extra spacing of 16px */
  @media (max-width: ${screenSmMax}) {
    height: ${spacer72};
  }
`;

export default function S4AHeader() {
  return (
    <>
      <NavBar
        colors={{
          background: creatorLightTheme.base.background.base,
          text: creatorLightTheme.base.text.base,
        }}
      />
      <Spacer />
    </>
  );
}
